<script>
import { HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: HorizontalBar,
  mixins: [ reactiveProp ],
  props: [ 'chartData' ],
  name: 'weeklySales',
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          //display: false,
          position: 'right',
        },
        parsing: {
          xAxisKey: 'id',
          yAxisKey: 'value',
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              return tooltipItem.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            },
          },
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
            },
            scaleLabel: {
              display: true,
              labelString: '時間(h)'
            }
          }],
          yAxes: [{
            ticks: {
              callback: function(name) {
                return name.substr(0, 10)
              },
            },
            scaleLabel: {
              display: true,
              labelString: '客先名'
            }
          }],
        },
      },
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },

}
</script>
